var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "basic-information" }, [
        _c("div", { staticClass: "basic-information-title" }, [
          _vm._v("基本信息")
        ]),
        _vm._v(" "),
        _vm.salesId == _vm.data.custBasicInfo.userId &&
        _vm.showCC == true &&
        _vm.hasModifyAuth
          ? _c("img", {
              staticClass: "redactImg",
              attrs: {
                src: require("@/assets/img/redact.png"),
                alt: "",
                srcset: ""
              },
              on: { click: _vm.redact }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "basic-information-flex" }, [
        _c("ul", { staticClass: "basic-information-lists" }, [
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("性别")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(
                _vm._s(
                  _vm.data.custBasicInfo.sex == 0
                    ? "男"
                    : _vm.data.custBasicInfo.sex == 1
                    ? "女"
                    : ""
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("生日")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.birthday))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("摄影主题")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.shootingTypeName))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("爱好")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.hobbyName))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("职业")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.occupationName))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("邮箱")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.email || ""))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("地区")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(
                _vm._s(_vm.data.custBasicInfo.provinceName) +
                  " " +
                  _vm._s(_vm.data.custBasicInfo.cityName)
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("地址")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.address))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("预估年龄")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.estimateAgeName))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("结婚纪念日")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.weddingDate))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("客户状态")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.Status))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("专属导购")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.shoppingAssistantName || ""))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("R24等级")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.brandLevel || ""))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("新/老客户分类")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(_vm._s(_vm.data.custBasicInfo.UNeworOldCustomer))
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("限量款购买者")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.data.custBasicInfo.limitedProdouctCustomer === 1
                      ? "是"
                      : _vm.data.custBasicInfo.limitedProdouctCustomer === 0
                      ? "否"
                      : ""
                  ) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "basic-information-lists-item" }, [
              _vm._v("易手机用户")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basic-information-lists-text" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.data.custBasicInfo.SecondHandCustomer === 1
                      ? "是"
                      : _vm.data.custBasicInfo.SecondHandCustomer === 0
                      ? "否"
                      : ""
                  ) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.data.custBasicInfo.remark
        ? _c("div", { staticClass: "basic-remark" }, [
            _c("div", { staticClass: "basic-information-title" }, [
              _vm._v("备注")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.data.custBasicInfo.remark
        ? _c("div", { staticClass: "remark-textarea" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.custBasicInfo.remark,
                  expression: "data.custBasicInfo.remark"
                }
              ],
              staticClass: "textarea",
              staticStyle: { border: "none" },
              attrs: { disabled: "true", cols: "30", rows: "10" },
              domProps: { value: _vm.data.custBasicInfo.remark },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.data.custBasicInfo,
                    "remark",
                    $event.target.value
                  )
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "basic-remark" }, [
        _c("div", { staticClass: "basic-information-title" }, [
          _vm._v("已拥有的徕卡产品")
        ]),
        _vm._v(" "),
        _c("img", {
          class: _vm.buyprod == false ? "arrowsC" : "arrowsCs",
          attrs: { src: require("@/assets/arrowsC.png"), alt: "", srcset: "" },
          on: {
            click: function($event) {
              return _vm.buyProdChange(_vm.buyprod)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.buyprod == true ? "camera-listActive" : "camera-list" },
        [
          _vm._l(_vm.buyprodObj.data, function(item, index) {
            return _c("div", { key: index, staticClass: "camera-item" }, [
              _c("div", [
                _c("span", { staticClass: "camera-brandName" }, [
                  _vm._v(_vm._s(item.Products1stType))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.ProductNameCH))])
              ])
            ])
          }),
          _vm._v(" "),
          !_vm.buyprodObj.lastPage
            ? _c(
                "div",
                {
                  staticClass: "loaded-data",
                  on: {
                    click: function($event) {
                      return _vm.getBuyProdList(_vm.custIdNow)
                    }
                  }
                },
                [_vm._v("\n            加载更多\n       ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.buyprodObj.lastPage
            ? _c("div", { staticClass: "loaded-no-data" }, [
                _vm._v("\n            没有更多数据了~\n       ")
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "basic-remark" }, [
        _c("div", { staticClass: "basic-information-title" }, [
          _vm._v("拥有其他相机")
        ]),
        _vm._v(" "),
        _c("img", {
          class: _vm.arrows == false ? "arrowsC" : "arrowsCs",
          attrs: { src: require("@/assets/arrowsC.png"), alt: "", srcset: "" },
          on: {
            click: function($event) {
              return _vm.arrowsChange(_vm.arrows)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.arrows == true ? "camera-listActive" : "camera-list" },
        _vm._l(_vm.cameraListeD, function(item, index) {
          return _c("div", { key: index, staticClass: "camera-item" }, [
            _c("img", {
              staticClass: "camera",
              attrs: { src: require("@/assets/img/camera.png"), alt: "" }
            }),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "camera-brandName" }, [
                _vm._v(_vm._s(item.brandName))
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.assetModel))])
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "models-right" },
        [
          _c(
            "van-popup",
            {
              attrs: {
                position: "right",
                overlay: true,
                "close-on-click-overlay": false
              },
              model: {
                value: _vm.basicShow,
                callback: function($$v) {
                  _vm.basicShow = $$v
                },
                expression: "basicShow"
              }
            },
            [
              _c("div", { staticClass: "basic-models" }, [
                _c(
                  "div",
                  { staticClass: "basic-models-list" },
                  [
                    _c(
                      "div",
                      { staticClass: "basic-models-list-item soursName" },
                      [
                        _c(
                          "div",
                          { staticClass: "models-list-item-title title1 must" },
                          [_vm._v("姓名")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pullList[0]["name"],
                              expression: "pullList[0]['name']"
                            }
                          ],
                          attrs: {
                            maxlength: "100",
                            placeholder: "请输入用户名"
                          },
                          domProps: { value: _vm.pullList[0]["name"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pullList[0],
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-item" }, [
                      _c(
                        "div",
                        { staticClass: "models-list-item-title title1 must" },
                        [_vm._v("性别")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selectUp",
                          on: {
                            click: function($event) {
                              return _vm.downSelections(0)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.pullList[1]["name"] || "请选择性别") +
                              "\n              "
                          ),
                          _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-item" }, [
                      _c(
                        "div",
                        { staticClass: "models-list-item-title title1" },
                        [_vm._v("生日")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selectUp",
                          on: {
                            click: function($event) {
                              return _vm.downTime(0)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.pullList[2]["name"] || "请选择") +
                              "\n              "
                          ),
                          _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "basic-models-list-itemS",
                        style: "border:none"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "models-list-item-title title1" },
                          [_vm._v("摄影主题")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "selectUp" })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "basic-models-list-Checkbox" },
                      _vm._l(_vm.ShootingType, function(item, index) {
                        return _c(
                          "van-checkbox",
                          {
                            key: index,
                            staticClass: "list-Checkbox-item",
                            attrs: { "checked-color": "#E10000" },
                            on: {
                              change: function($event) {
                                return _vm.checkboxCahnge(index, 1)
                              }
                            },
                            model: {
                              value: item.edit,
                              callback: function($$v) {
                                _vm.$set(item, "edit", $$v)
                              },
                              expression: "item.edit"
                            }
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "textareas-inputs" }, [
                      _c(
                        "div",
                        {
                          staticClass: "basic-models-list-itemS textareas",
                          staticStyle: { "margin-left": "0" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pullList[3]["name"],
                                expression: "pullList[3]['name']"
                              }
                            ],
                            attrs: {
                              type: "text",
                              disabled: _vm.ShootingTypeEdit,
                              placeholder: "输入客户偏爱的摄影主题"
                            },
                            domProps: { value: _vm.pullList[3]["name"] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.pullList[3],
                                  "name",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "basic-models-list-itemS",
                        style: "border:none"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "models-list-item-title title1" },
                          [_vm._v("兴趣爱好")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "selectUp" })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "basic-models-list-Checkbox" },
                      _vm._l(_vm.Hobby, function(item, index) {
                        return _c(
                          "van-checkbox",
                          {
                            key: index,
                            staticClass: "list-Checkbox-item",
                            attrs: { "checked-color": "#E10000" },
                            on: {
                              change: function($event) {
                                return _vm.checkboxCahnge(index, 2)
                              }
                            },
                            model: {
                              value: item.edit,
                              callback: function($$v) {
                                _vm.$set(item, "edit", $$v)
                              },
                              expression: "item.edit"
                            }
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "textareas-inputs" }, [
                      _c(
                        "div",
                        {
                          staticClass: "basic-models-list-itemS textareas",
                          staticStyle: { "margin-left": "0" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.pullList[4]["name"],
                                expression: "pullList[4]['name']"
                              }
                            ],
                            attrs: {
                              type: "text",
                              disabled: _vm.HobbyEdit,
                              placeholder: "输入客户偏爱的兴趣爱好"
                            },
                            domProps: { value: _vm.pullList[4]["name"] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.pullList[4],
                                  "name",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-item" }, [
                      _c(
                        "div",
                        { staticClass: "models-list-item-title title1" },
                        [_vm._v("职业")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selectUp",
                          on: {
                            click: function($event) {
                              return _vm.downSelections(1)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.pullList[5]["name"] || "选择职业") +
                              "\n              "
                          ),
                          _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-item" }, [
                      _c(
                        "div",
                        { staticClass: "models-list-item-title title1" },
                        [_vm._v("结婚纪念日")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selectUp",
                          on: {
                            click: function($event) {
                              return _vm.downTime(1)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.pullList[6]["name"] || "请选择") +
                              "\n              "
                          ),
                          _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "basic-models-list-item soursName" },
                      [
                        _c(
                          "div",
                          { staticClass: "models-list-item-title title1" },
                          [_vm._v("邮箱")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.obj.email,
                              expression: "obj.email"
                            }
                          ],
                          attrs: {
                            maxlength: "100",
                            placeholder: "请输入邮箱"
                          },
                          domProps: { value: _vm.obj.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.obj, "email", $event.target.value)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-item" }, [
                      _c(
                        "div",
                        { staticClass: "models-list-item-title title1" },
                        [_vm._v("地区")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "region",
                          on: {
                            click: function($event) {
                              return _vm.downSelections(11)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.province.name || "请选择") +
                              "\n              "
                          ),
                          _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "region",
                          on: {
                            click: function($event) {
                              _vm.province.name ? _vm.downSelections(12) : ""
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.city.name || "请选择") +
                              "\n              "
                          ),
                          _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-item" }, [
                      _c(
                        "div",
                        { staticClass: "models-list-item-title title1" },
                        [_vm._v("地址")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "selectUp" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pullList[7]["name"],
                              expression: "pullList[7]['name']"
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "25",
                            placeholder: "请输入详细地址"
                          },
                          domProps: { value: _vm.pullList[7]["name"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pullList[7],
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-item" }, [
                      _c(
                        "div",
                        { staticClass: "models-list-item-title title1 must" },
                        [_vm._v("预估年龄")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "selectUp",
                          on: {
                            click: function($event) {
                              return _vm.downSelections(2)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.pullList[8]["name"] || "选择预估年龄"
                              ) +
                              "\n              "
                          ),
                          _c("img", {
                            staticClass: "uparrow",
                            attrs: {
                              src: require("@/assets/img/uparrow.png"),
                              alt: "",
                              srcset: ""
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-item" }, [
                      _c(
                        "div",
                        { staticClass: "models-list-item-title title1" },
                        [_vm._v("备注")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "selectUp" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pullList[9]["name"],
                              expression: "pullList[9]['name']"
                            }
                          ],
                          attrs: {
                            maxlength: "1024",
                            placeholder: "请输入备注信息",
                            cols: "30",
                            rows: "10"
                          },
                          domProps: { value: _vm.pullList[9]["name"] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.pullList[9],
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "basic-models-list-itemS" }, [
                      _c(
                        "div",
                        {
                          staticClass: "models-list-item-title title1",
                          style: "width:3rem"
                        },
                        [_vm._v("拥有其它相机")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "selectUp" })
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.cameraList, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "addCamera" },
                        [
                          _c("div", { staticClass: "camera-delete" }, [
                            _c("div", [_vm._v("No." + _vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "delete",
                              attrs: {
                                src: require("@/assets/img/delete.png"),
                                alt: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteCamera(index)
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "camera-flex" }, [
                            _c("div", { staticClass: "camera-name title1" }, [
                              _vm._v("品牌")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "camera-selectUp",
                                on: {
                                  click: function($event) {
                                    return _vm.downSelections(3, index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.name || "请选择品牌") +
                                    "\n                "
                                ),
                                _c("img", {
                                  staticClass: "uparrow",
                                  attrs: {
                                    src: require("@/assets/img/uparrow.png"),
                                    alt: "",
                                    srcset: ""
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "camera-flex" }, [
                            _c("div", { staticClass: "camera-name title1" }, [
                              _vm._v("型号")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "camera-selectUp" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: item.model,
                                    expression: "item.model"
                                  }
                                ],
                                staticClass: "camera-selectUpInput",
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入相机型号"
                                },
                                domProps: { value: item.model },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(item, "model", $event.target.value)
                                  }
                                }
                              })
                            ])
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.showCC == true
                      ? _c(
                          "div",
                          {
                            staticClass: "add-button",
                            on: { click: _vm.addCamera }
                          },
                          [_vm._v("＋添加相机")]
                        )
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "position-bottom-button" }, [
                  _c("div", { staticClass: "confirm-cancel" }, [
                    _c(
                      "div",
                      { staticClass: "button-flex-color flex-border-button" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "button-flex-item",
                            on: { click: _vm.cancelBasic }
                          },
                          [_vm._v("取消")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "button-flex-color" }, [
                      _c(
                        "div",
                        {
                          staticClass: "button-flex-item button-active",
                          on: { click: _vm.confirmBasic }
                        },
                        [_vm._v("确定")]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticStyle: { width: "100%" },
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.timeShow,
            callback: function($$v) {
              _vm.timeShow = $$v
            },
            expression: "timeShow"
          }
        },
        [
          _c("van-datetime-picker", {
            attrs: {
              type: "date",
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate
            },
            on: {
              confirm: _vm.timeConfirm,
              cancel: _vm.timeCancel,
              change: _vm.timeChange
            },
            model: {
              value: _vm.currentDate,
              callback: function($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.showDownSelection,
            callback: function($$v) {
              _vm.showDownSelection = $$v
            },
            expression: "showDownSelection"
          }
        },
        [
          _c("van-picker", {
            staticClass: "van-picker-li",
            attrs: {
              "show-toolbar": "",
              title: "",
              columns: _vm.downSelection,
              "value-key": "name"
            },
            on: { cancel: _vm.onCancelCode, confirm: _vm.onConfirmCode }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14736aad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14736aad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/basicInformation.vue
// module id = null
// module chunks = 